<template>
  <login-shell>
    <div class="signin-form">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <br />
      <form v-on:submit.prevent="signinUser()">
        <div class="text-center">
          <label>{{otpInfoText}}</label>
        </div>
        <div class="otp-box">
          <p class="label">Enter OTP</p>
          <div class="flex-box">
            <input
              ref="otp1"
              class="input-field custom-Input margin-right-8"
              autocomplete="off"
              id="otp1"
              type="text"
              name="otp1"
              autofocus
              v-model="formData.otp1"
              maxlength="1"
              v-on:keypress="numberOnly($event,1)"
              v-on:keyup="keyupInputVal($event,1)"
            />
            <input
              ref="otp2"
              class="input-field custom-Input margin-left-8 margin-right-8"
              autocomplete="off"
              id="otp2"
              type="text"
              name="otp2"
              v-model="formData.otp2"
              maxlength="1"
              v-on:keypress="numberOnly($event,2)"
              v-on:keyup="keyupInputVal($event,2)"
            />
            <input
              ref="otp3"
              class="input-field custom-Input margin-left-8 margin-right-8"
              autocomplete="off"
              id="otp3"
              type="text"
              name="otp3"
              v-model="formData.otp3"
              maxlength="1"
              v-on:keypress="numberOnly($event,3)"
              v-on:keyup="keyupInputVal($event,3)"
            />
            <input
              ref="otp4"
              class="input-field custom-Input margin-left-8 margin-right-8"
              autocomplete="off"
              id="otp4"
              type="text"
              name="otp4"
              v-model="formData.otp4"
              maxlength="1"
              v-on:keypress="numberOnly($event,4)"
              v-on:keyup="keyupInputVal($event,4)"
            />
            <input
              ref="otp5"
              class="input-field custom-Input margin-left-8 margin-right-8"
              autocomplete="off"
              id="otp5"
              type="text"
              name="otp5"
              v-model="formData.otp5"
              maxlength="1"
              v-on:keypress="numberOnly($event,5)"
              v-on:keyup="keyupInputVal($event,5)"
            />
            <input
              ref="otp6"
              class="input-field custom-Input margin-left-8"
              autocomplete="off"
              id="otp6"
              type="text"
              name="otp6"
              v-model="formData.otp6"
              maxlength="1"
              v-on:keypress="numberOnly($event,6)"
              v-on:keyup="keyupInputVal($event,6)"
            />
          </div>
          <div class="checkbox resendOtp">
            <label class="timer-label">{{timerText()}}</label>
            <a
              :class="{'disableResendOTP': !isResendOtpEnabled, 'request-otp': isResendOtpEnabled}"
              @click="callResendOTP"
            >Resend OTP</a>
          </div>
        </div>
        <button type="submit" class="signin-btn">Back to Sign-in</button>
      </form>

      <pop-up-message v-if="showResendOTPSuccessMsg" :message="otpInfoText" btnText="OK" @back="ok"></pop-up-message>
    </div>
  </login-shell>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      otpInfoText: "",
      showResendOTPSuccessMsg: false,
      tiltedMailId: "",
      mobileNumber: "",
      isResendOtpEnabled: false,
      timeLeft: 180,
      interval: null,
      toast: false,
      errmsg: "",
      formData: {
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
        otp5: "",
        otp6: ""
      },
      time: 30,
      showSuccessMsg: false
    };
  },
  components: {},

  computed: {
    ...mapState({
      authState: state => state.auth
    })
  },

  mounted() {
    this.setTiltedMail();
    this.setTiltedMobile();
    this.initiateTimer();
    this.setHeaderInfo();
    this.$refs.otp1.focus();
  },

  activated() {
    this.startTimer();
    this.$refs.otp1.focus();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    ...mapGetters({
      isAuth: "auth/isAuth"
    }),
    ...mapActions({
      signinUsingPassword: "auth/signinUsingPassword",
      signInWithGoogle: "auth/signInWithGoogle",
      userForgotPassword: "auth/forgotPassword",
      verifyOTP: "auth/verifyOTP",
      resendOTP: "auth/resendOTP"
    }),

    /** To show the data info to user regarding mail and mobile for which OTP has been sent*/
    setHeaderInfo() {
      try {
        let tiltedMail = this.setTiltedMail();
        let titltedMobile = this.setTiltedMobile();

        let finalStr = "";
        let tiltedMailStr = tiltedMail
          ? "OTP has been sent to " + tiltedMail
          : "";
        let tiltedMobileNumStr = titltedMobile
          ? (tiltedMailStr ? " and " : " ") + titltedMobile
          : "";
        finalStr = tiltedMailStr + tiltedMobileNumStr;
        this.otpInfoText = finalStr;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    back() {
      this.$router.go(-1);
    },

    /** To convert a email id to a titlted mail id */
    setTiltedMail() {
      try {
        let encodedStr = this.getEmailEncryptedString();
        if (encodedStr) {
          var decodedString = atob(encodedStr);
          var res = decodedString.split("@");
          this.tiltedMailId = res[0].substr(0, 2) + "******@" + res[1];
          return this.tiltedMailId;
        } else {
          return null;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** To convert a mobile num to a titlted mobile num */
    setTiltedMobile() {
      try {
        let encodedStr = this.getMobileEncryptedString();
        if (encodedStr) {
          var decodedString = atob(encodedStr);
          this.mobileNumber =
            decodedString.substr(0, 2) + "******" + decodedString.substr(8, 10);
          return this.mobileNumber;
        } else {
          return null;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Server call to resend OTP to mail id and email*/
    async callResendOTP() {
      try {
        let encodedStr = this.getEmailEncryptedString();
        var decodedString = atob(encodedStr);

        let data = await this.resendOTP({
          identity: decodedString
        });

        if (data && data.status) {
          this.showResendOTPSuccessMsg = true;
          this.isResendOtpEnabled = false;
          this.interval = null;
          this.timeLeft = 180;
          this.formData.otp1 = "";
          this.formData.otp2 = "";
          this.formData.otp3 = "";
          this.formData.otp4 = "";
          this.formData.otp5 = "";
          this.formData.otp6 = "";
          this.initiateTimer();
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Function to setup the time interval */
    initiateTimer() {
      try {
        this.interval = setInterval(() => this.timerFunction(), 1000);
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Logic to setup the timer */
    timerFunction() {
      try {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.isResendOtpEnabled = true;
          clearInterval(this.interval);
          this.timeLeft = 0;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Timer text to display on UI */
    timerText() {
      try {
        let minutes = Math.floor(this.timeLeft / 60);
        let seconds = Math.floor(this.timeLeft % 60);

        if (seconds < 10) {
          return minutes + ":" + "0" + seconds;
        } else {
          return minutes + ":" + seconds;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Logic to allow only the numbers in input */
    numberOnly(event, inputId) {
      try {
        const charCode = event.which ? event.which : event.keyCode;
        let value = event.target.value + "" + event.key;
        let length = value.substring(value.indexOf(".")).length;

        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode != 46
        ) {
          event.preventDefault();
          return false;
        } else if (length > 3 && value.indexOf(".") > 0) {
          event.preventDefault();
          return false;
        } else if (value.indexOf(".") != value.lastIndexOf(".")) {
          event.preventDefault();
          return false;
        } else if (value == ".") {
          event.preventDefault();
          return false;
        }

        return true;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Logic to jump to next input on entering a num in one input*/
    keyupInputVal(event, inputId) {
      try {
        if (
          event.keyCode == 49 ||
          event.keyCode == 50 ||
          event.keyCode == 51 ||
          event.keyCode == 52 ||
          event.keyCode == 53 ||
          event.keyCode == 54 ||
          event.keyCode == 55 ||
          event.keyCode == 56 ||
          event.keyCode == 57 ||
          event.keyCode == 48 ||
          event.keyCode == 8 ||
          event.keyCode == 96 ||
          event.keyCode == 97 ||
          event.keyCode == 98 ||
          event.keyCode == 99 ||
          event.keyCode == 100 ||
          event.keyCode == 101 ||
          event.keyCode == 102 ||
          event.keyCode == 103 ||
          event.keyCode == 104 ||
          event.keyCode == 105
        ) {
          if (inputId == 1) {
            if (!(event.keyCode == 8)) {
              this.formData.otp1 = event.key;
              this.$refs.otp2.focus();
            }
          } else if (inputId == 2) {
            if (event.keyCode == 8) {
              this.$refs.otp1.focus();
            } else {
              this.formData.otp2 = event.key;
              this.$refs.otp3.focus();
            }
          } else if (inputId == 3) {
            if (event.keyCode == 8) {
              this.$refs.otp2.focus();
            } else {
              this.formData.otp3 = event.key;
              this.$refs.otp4.focus();
            }
          } else if (inputId == 4) {
            if (event.keyCode == 8) {
              this.$refs.otp3.focus();
            } else {
              this.formData.otp4 = event.key;
              this.$refs.otp5.focus();
            }
          } else if (inputId == 5) {
            if (event.keyCode == 8) {
              this.$refs.otp4.focus();
            } else {
              this.formData.otp5 = event.key;
              this.$refs.otp6.focus();
            }
          } else if (inputId == 6) {
            if (event.keyCode == 8) {
              this.$refs.otp5.focus();
            } else {
              this.formData.otp6 = event.key;
            }
          }
          this.performAction();
          event.preventDefault();
        } else {
          event.preventDefault();
          return false;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Function to get email string from query params */
    getEmailEncryptedString() {
      try {
        return this.$route.query.email ? this.$route.query.email : null;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Function to get mobile num string from query params */
    getMobileEncryptedString() {
      try {
        return this.$route.query.mobile ? this.$route.query.mobile : null;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Function to start a timer */
    startTimer() {
      try {
        this.interval = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--;
          } else {
            this.isResendOtpEnabled = true;
            clearInterval(this.interval);
            this.timeLeft = 0;
          }
        }, 1000);
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    async signinUser() {
      this.$router.go(-1);
    },

    /** Server call action */
    async performAction() {
      try {
        let encodedStr = this.getEmailEncryptedString();
        var decodedString = atob(encodedStr);
        let otp =
          this.formData.otp1 +
          this.formData.otp2 +
          this.formData.otp3 +
          this.formData.otp4 +
          this.formData.otp5 +
          this.formData.otp6;
        if (otp.length == 6) {
          let data = await this.verifyOTP({
            identity: decodedString, //decodedString,
            otp: otp
          });
          if (data && data.status) {
            //set token
            window.localStorage.setItem(
              "token",
              JSON.stringify(data.data.payload.token)
            );
            this.toast = false;
            /**  Commented to stop the two factor authentication
              //loading all the modules for store
              // this.$store.registerModule("onboard",module_onboard,{ preserveState: true });
              // this.$store.registerModule("payroll",module_payroll,{ preserveState: true });
              // this.$store.registerModule("dashboard",module_dashboard,{ preserveState: true });
              // this.$store.registerModule("globalapi",module_globalapis ,{ preserveState: true });
              */
            if (localStorage.getItem("token")) {
              setTimeout(() => {
                if (!this.$route.query.entry_url) {
                  this.$router.push({ path: "/welcome" });
                } else {
                  this.$router.push({ path: this.$route.query.entry_url });
                }
                window.location.reload();
              }, 100);
            }
          }
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** On logging by Gmail */
    async onSignIn(googleUser) {
      try {
        let email = googleUser.getBasicProfile().getEmail();
        let token = googleUser.getAuthResponse().id_token;
        await this.signInWithGoogle({
          identity: email,
          token: token
        });
        /**  Commented to stop the two factor authentication
        // if (data.message != null) {
        //   throw Error(data.message);
        // }
        // this.$router.push({
        //   path: "/onboarding"
        // });
        */
        this.$router.push({
          path: "/orgsummary"
        });
      } catch (err) {
        this.errmsg = err.message;
        this.toast = true;
      }
    },
    cancel() {},

    ok() {
      this.showSuccessMsg = false;
      this.showResendOTPSuccessMsg = false;
    }
  }
};
</script>

<style lang='scss' scoped>
.margin-20 {
  margin-top: 20px;
}

.disableResendOTP {
  pointer-events: none;
  font-family: Montserrat;
  font-size: 13px;
  text-decoration: none;
  margin-left: auto;
  color: #5d409f;
  opacity: 0.5;
}

.otp-box {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.text-center {
  text-align: center;
}

.signin-form {
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
}

.signin-form form {
  padding: 10px 40px 25px;
}

.signin-button .google-img {
  height: 50px;
  width: 50px;
}

.or {
  display: flex;
  align-items: center;
}
.flex-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.or span {
  margin: 0 25px;
  color: #5d409f;
}

.label {
  height: 15px; // margin-top: 25px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 13px;
  color: #0e0e0e;
}

.signin-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 6px;
  padding: 10px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
}

.checkbox {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.resendOtp {
  display: flex;
  justify-content: space-between;
}

.request-otp {
  cursor: pointer;
  font-family: Montserrat;
  font-size: 13px;
  text-decoration: none;
  margin-left: auto;
  color: #5d409f;
}

.timer-label {
  font-family: Montserrat;
  font-size: 13px;
  text-decoration: none;
  color: #5d409f;
}

.signin-btn {
  margin-top: 50px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}

.opt-input-field {
  margin-top: 27px;
  display: flex;
  justify-content: space-between;
}

.opt-input-field input {
  width: 46px;
  height: 46px;
  outline: 0;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 18px;
  &:focus {
    border: 1px solid #5d409f;
  }
}

.otp-time {
  display: flex;
  margin-top: 10px;
}

.otp-time button {
  margin-left: auto;
  cursor: pointer;
  width: 105px;
  height: 15px;
  opacity: 0.41;
  font-family: Montserrat;
  font-size: 12px;
  text-align: right;
  color: #7a797d;
}

.custom-Input {
  width: 15% !important;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}

.margin-right-8 {
  margin-right: 10px;
}

.margin-left-8 {
  margin-left: 10px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media only screen and (max-width: 600px) {
  .signin-form form {
    padding: 16px 20px 25px;
  }
}
</style>
